import React, { useMemo } from 'react';
import { Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { BootstrapGenericTable } from '@components/Table/Table';

const exportContent = (visible, setVisible) => (
  <Button variant="didxl" size="sm" onClick={() => setVisible(!visible)}>
    New
  </Button>
);

const renderActionCell = ({ row }) => {
  const trunkID = row.original.id;
  return (
    <Button
      as={Link}
      size="sm"
      to={`/capacity/trunks/${trunkID}/edit`}
      variant="didxl"
    >
      Edit
    </Button>
  );
};

export const TrunksTable = ({ useData, setVisible, visible }) => {
  const columns = useMemo(
    () => [
      {
        id: 'id',
        accessor: 'id',
      },
      {
        id: 'name',
        Header: 'Name',
        accessor: 'name',
        className: 'col-md-3',
      },
      {
        Header: '# Channels',
        accessor: 'channels',
        className: 'col-md-1 text-center',
      },
      {
        id: 'prefix',
        Header: 'Prefix',
        accessor: 'prefix',
        className: 'col-md-2 text-center',
      },
      {
        Header: '#DIDs',
        accessor: 'amount_dids',
        className: 'col-md-1 text-center',
      },
      {
        Header: 'Type',
        accessor: 'type.name',
        className: 'col-md-1 text-center',
      },
      {
        Header: 'Action',
        className: 'col-md-1 text-center',
        Cell: renderActionCell,
      },
    ],
    []
  );
  return (
    <Card>
      <Card.Header className="bg-didxl text-white">Trunk manager</Card.Header>
      <Card.Body>
        <BootstrapGenericTable
          columns={columns}
          useData={useData}
          filterData={{}}
          tableProps={() => ({
            responsive: true,
            bordered: true,
            className: 'normalFontSize',
          })}
          paginated
          hiddenColumns="id"
          exportContent={() => exportContent(visible, setVisible)}
        />
      </Card.Body>
    </Card>
  );
};
